import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { CuentaContable } from '../../../models/cuenta-contable';
import { Pagination } from '../../../models/pagination';
import { TipoCuenta } from '../../../models/tipo-cuenta';
import { CuentaContableService } from '../../../services/cuenta-contable.service';
import { SessionService } from '../../../services/session.service';
import { TipoCuentaService } from '../../../services/tipo-cuenta.service';

@Component({
  selector: 'app-cuenta-contable-banco-modal',
  templateUrl: './cuenta-contable-banco-modal.component.html',
  styleUrls: ['./cuenta-contable-banco-modal.component.css'],
  providers:[
    TipoCuentaService,
    CuentaContableService
  ]
})
export class CuentaContableBancoModalComponent implements OnInit {
  @Output() sendCuenta = new EventEmitter();
  public tiposCuenta: Array<TipoCuenta>;
  public cuentasContable: Array<CuentaContable>;
  public tipoCuenta: TipoCuenta;
  public cuentaContable: CuentaContable;
  public pagination: Pagination;
  public busqueda: String;
  public selectedRow: Number;
  public loading: boolean;

  constructor(
    private tipoCuentaService: TipoCuentaService,
    public bsModalRef: BsModalRef,
    private cuentaContableService: CuentaContableService,
    private ss: SessionService,
  ) {
    this.tiposCuenta = [];
    
    this.cuentasContable = [];
    this.tipoCuenta = new TipoCuenta();
    this.cuentaContable = new CuentaContable();
    this.pagination = new Pagination();
    this.busqueda = "";
    this.loading = false;
  }

  ngOnInit() {
    this.loading = true;
    this.getTiposCuenta().then(
      res=>{
        this.getCuentaContable().then(
          res => this.loading = false,
          err => this.loading = false,
        );
      },
      err => this.loading = false,
    );
  }
  onChangeSelect(){
    this.loading = true;
    this.pagination = new Pagination();
    this.getCuentaContable().then(
      res => this.loading = false,
      err => this.loading = false,
    )
  }

  getTiposCuenta(){
    return new Promise((resolve, reject)=>{
      this.tipoCuentaService.getAll("?status=A").subscribe(
        res =>{
          this.tiposCuenta = res.data;
          this.tipoCuenta.id = this.tiposCuenta[0].id;
          resolve();
        },
        err =>{
          reject();
        });
    });
  }

  getCuentasBySearch(text) {
		this.busqueda = text;
		let qs ="";
		if (this.busqueda != "") {
			qs = this.getQs();
		}
		this.pagination.current_page = 1;
		this.getCuentaContable(qs);
	}

	getQs(){
		return "&q[codigo]=" + this.busqueda + "&q[nombre]=" + this.busqueda;
	}

  getCuentaContable(qs = "") {
		return new Promise((resolve, reject) => {
			this.loading = true;
      this.cuentaContableService.getAll("?page=" + this.pagination.current_page + "&per_page=10&embed=tipocuenta,nivelcuenta&status=A&tipo_cuenta_id="+ 
        this.tipoCuenta.id + "&empresa_id="+this.ss.getData('empresa_id') +"&padre_id=9"+ qs).subscribe(
				res => {
					this.cuentasContable = res.data;
					this.loading = false;
					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;

					resolve();
				},
				err => {
          this.loading = false;
					reject();
				});
		});
  }
  
  getIndexNumber(i){
    return this.pagination.from+i;
  }

  next(){
    this.loading = true;
		let qs ="";
		if (this.busqueda != "") {
			qs = this.getQs();
		}
		this.pagination.current_page++;
		this.getCuentaContable(qs).then(
      res => this.loading = false,
      err => this.loading = false,
    );
	}

	prev(){
    this.loading = true;
		let qs ="";
		if (this.busqueda != "") {
			qs = this.getQs();
		}
		this.pagination.current_page--;
    this.getCuentaContable(qs).then(
      res => this.loading = false,
      err => this.loading = false,
    );
	}

	first(){
    this.loading = true;
		let qs ="";
		if (this.busqueda != "") {
			qs = this.getQs();
		}
		this.pagination.current_page = 1;
		this.getCuentaContable(qs).then(
      res => this.loading = false,
      err => this.loading = false,
    );
	}

	last(){
    this.loading = true;
		let qs ="";
		if (this.busqueda != "") {
			qs = this.getQs();
		}
		this.pagination.current_page = this.pagination.last_page;
		this.getCuentaContable(qs).then(
      res => this.loading = false,
      err => this.loading = false,
    );
	}

	onSelectRow(cuenta, i) {
		
		this.selectedRow = i;
		
		this.cuentaContable = cuenta;
	}

	onDBLClick(cuenta,i)
	{
		this.onSelectRow(cuenta,i);
		this.onSubmit();
	}

	onSubmit() {
		
		this.sendCuenta.emit(this.cuentaContable);
		
		this.bsModalRef.hide();
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/cuenta-contable-banco-modal/cuenta-contable-banco-modal.component.ts